import get from 'lodash/get'

// Markets where planners can proceed without requiring a signed contract
const MARKETS_WITH_NO_CONTRACT_REQUIREMENT = [
  'zurihealth',
  'karen',
  'nasdma',
  'rjolad',
  'nhsp',
  'reliance',
  'antara',
  'penda'
]

export function checkForPatientGroup (group) {
  return group.patientName || group.patientId
}

export const isMarketWithNoContractRequirement = (location) => {
  const market = get(location, 'location.state')
  return MARKETS_WITH_NO_CONTRACT_REQUIREMENT.includes(market)
}
